import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IRutaEtapaEvaluaciones } from 'graphql/types/ruta_etapa_evaluaciones';

const initialState: IRutaEtapaEvaluaciones | any = null;

const currentRutaEtapaEvaluacionSlice = createSlice({
	name: 'currentRutaEtapaEvaluacion',
	initialState,
	reducers: {
		setCurrentRutaEtapaEvaluacion: (state, action: PayloadAction<IRutaEtapaEvaluaciones | any>) => {
			if (action.payload === null) {
				return initialState;
			}
			return action.payload;
		},
		resetCurrentRutaEtapaEvaluacion: () => {
			return initialState;
		}
	}
});

export const { setCurrentRutaEtapaEvaluacion, resetCurrentRutaEtapaEvaluacion } =
	currentRutaEtapaEvaluacionSlice.actions;

export default currentRutaEtapaEvaluacionSlice.reducer;
